import Arrow from '@monofront/design-system/visuals/Icons/Old/Arrow';
import Button from '@monofront/design-system/components/Button';
import { useTranslations } from 'next-intl';
import { Dispatch, SetStateAction } from 'react';
import { ELIGIBILITY_STATUS } from '@monofront/business/constants';

interface IFreshHeaderProps {
  setFreshStatus: Dispatch<SetStateAction<ELIGIBILITY_STATUS>>;
  freshStatus: ELIGIBILITY_STATUS;
  title?: string;
}

const FreshHeader: React.FC<IFreshHeaderProps> = ({
  setFreshStatus,
  freshStatus,
  title,
}) => {
  const tGlobal = useTranslations('Global');
  const tFresh = useTranslations('Fresh');

  return (
    <>
      {[
        ELIGIBILITY_STATUS.ELIGIBLE_FOR_FRESH,
        ELIGIBILITY_STATUS.NOTIFICATION_FORM,
      ].includes(freshStatus) && (
        <Button
          variant="clear"
          className="fresh-back-button"
          onClick={() => setFreshStatus(ELIGIBILITY_STATUS.ADDRESS_FORM)}
          ariaLabel={tGlobal('back')}
        >
          <Arrow
            headDirection="left"
            color="var(--black)"
            width={14}
            height={14}
            aria-hidden
          />
        </Button>
      )}
      <h2 className="title-xs title">{title ?? tFresh('checkAddressTitle')}</h2>
      <style jsx>{`
        .title {
          transform: translateY(2px);
        }

        @media (max-width: 800px) {
          .title {
            text-align: center;
            font-size: var(--font-size-1-5);
            margin: auto;
          }
        }
      `}</style>
    </>
  );
};

export default FreshHeader;
